var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M13.657 9.506c.22.22.34.514.34.826 0 .312-.12.606-.34.826-.453.455-1.19.455-1.643 0L8 7.3l-4.02 3.858c-.22.22-.51.342-.82.342-.312 0-.603-.12-.822-.342-.22-.22-.34-.514-.34-.826 0-.312.12-.605.34-.825l4.838-4.865c.22-.22.51-.342.82-.342.31 0 .603.122.822.342l4.84 4.864z"}));
}

ArrowUp.defaultProps = {"width":"50","height":"50","viewBox":"0 0 16 16"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
